module.exports = __webpack_public_path__ + "static/img/ContacCode2.0e7573f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/ContacCode2.jpg
// module id = m/iB
// module chunks = 1